import { render, staticRenderFns } from "./rangepdl.vue?vue&type=template&id=45a88e50&scoped=true"
import script from "./rangepdl.vue?vue&type=script&lang=js"
export * from "./rangepdl.vue?vue&type=script&lang=js"
import style0 from "./rangepdl.vue?vue&type=style&index=0&id=45a88e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a88e50",
  null
  
)

export default component.exports